export const AboutText = {
  title: 'TECHNOLOGY',
  contentItems: [
    {
      header: 'PROFILE',
      listItems: ['SENIOR SOFTWARE ENGINEER', 'FULL-STACK', 'NVIDIA'],
    },
    {
      header: 'STATISTICS',
      listItems: ['5 YOE', 'BS COMP SCI', 'UMD, COLLEGE PARK'],
    },
    {
      header: 'INTERESTS',
      listItems: ['PC BUILDS', 'KEYBOARD BUILDS', 'FRONTEND NEWS'],
    },
  ],
};
